export default __webpack_public_path__ + "static/uk-fe78daad67ca2b9a4f66d48ec8fa6105.jpg";